/**
 * Returns a customized WhatsApp link with a message mapped to the specific page or service.
 * @param path The current URL path or canonical identifier
 */
export const getWhatsAppUrlByPath = (path: string): string => {
  const phoneNumber = "966566900924";
  let message = "السلام عليكم، أرغب في الحصول على استشارة بخصوص تأسيس وتطوير السجلات والأعمال في السعودية.";

  const normalizedPath = path.toLowerCase();

  if (normalizedPath.includes('company-formation-saudi-arabia') || normalizedPath.includes('company-setup-saudi-arabia')) {
    message = "مرحبًا، أرغب في الاستفسار عن خدمة تأسيس الشركات في السعودية.";
  } else if (normalizedPath.includes('commercial-registration-saudi-arabia')) {
    message = "مرحبًا، أرغب في الاستفسار عن خدمة استخراج أو تعديل السجل التجاري.";
  } else if (normalizedPath.includes('commercial-licenses-saudi-arabia') || normalizedPath.includes('business-licenses-saudi-arabia')) {
    message = "مرحبًا، أرغب في الاستفسار عن خدمة استخراج التراخيص التجارية.";
  } else if (normalizedPath.includes('foreign-business-setup') || normalizedPath.includes('foreign-investor-setup') || normalizedPath.includes('foreign-investment-service')) {
    message = "مرحبًا، أرغب في الاستفسار عن خدمات تأسيس شركة أو نشاط للمستثمر الأجنبي في السعودية.";
  } else if (normalizedPath.includes('riyadh')) {
    message = "مرحبًا، أرغب في الاستفسار عن خدمة تأسيس شركة في الرياض.";
  } else if (normalizedPath.includes('jeddah')) {
    message = "مرحبًا، أرغب في الاستفسار عن خدمة تأسيس شركة في جدة.";
  } else if (normalizedPath.includes('dammam')) {
    message = "مرحبًا، أرغب في الاستفسار عن خدمة تأسيس شركة في الدمام.";
  } else if (normalizedPath.includes('khobar')) {
    message = "مرحبًا، أرغب في الاستفسار عن خدمة تأسيس شركة في الخبر.";
  } else if (normalizedPath.includes('contact')) {
    message = "مرحبًا، أرغب في التواصل معكم بخصوص خدمات تأسيس الشركات والتراخيص.";
  } else if (normalizedPath.includes('open-company-saudi-arabia-cost-foreign-investment')) {
    message = "السلام عليكم، قرأت مقالكم حول فتح شركة في السعودية تكلفتها وشروطها، وأرغب في استشارة خاصة ببدء مشروعي.";
  } else if (normalizedPath.includes('/blog')) {
    message = "مرحبًا، قرأت مقالًا في موقعكم وأرغب في معرفة الخدمة المناسبة لحالتي.";
  }

  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
};

/**
 * Tracks WhatsApp clicks or direct messaging events globally for consistency
 */
export const trackWhatsAppClick = (location: string, text: string = 'واتساب') => {
  const anyWindow = window as any;
  anyWindow.dataLayer = anyWindow.dataLayer || [];
  anyWindow.dataLayer.push({
    event: 'whatsapp_click',
    click_type: 'whatsapp',
    page_path: window.location.pathname,
    page_title: document.title,
    button_location: location,
    link_text: text,
    link_url: getWhatsAppUrlByPath(window.location.pathname)
  });
};
